import React from "react";
import { Pagination, Stack } from "@mui/material";

const PaginationOfTable = ({ page, setPage, totalUsers, rowsPerPage }) => {
  const totalPages = Math.ceil(totalUsers / rowsPerPage);

  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        my: 3,
        "& .MuiPaginationItem-root": {
          fontSize: "1rem", // Custom font size
          padding: "8px 12px",
          borderRadius: "8px",
          transition: "all 0.3s ease-in-out",
        },
        "& .MuiPaginationItem-root:hover": {
          backgroundColor: "#1976d2",
          color: "#fff",
        },
        "& .Mui-selected": {
          backgroundColor: "#1976d2 !important",
          color: "#fff",
          fontWeight: "bold",
          boxShadow: "0px 3px 6px rgb(255, 3, 3)",
        },
      }}
    >
      <Pagination
        count={totalPages}
        page={page}
        onChange={(event, value) => setPage(value)}
        color="primary"
        variant="outlined"
        shape="rounded"
      />
    </Stack>
  );
};

export default PaginationOfTable;
